import { lazy } from 'react';

// project imports
import GuestGuard from 'utils/route-guard/GuestGuard';
import MinimalLayout from 'layout/MinimalLayout';
import NavMotion from 'layout/NavMotion';
import Loadable from 'ui-component/Loadable';
import TwoFactorSetupPage from 'ui-component/TwoFactorSetupPage';

// login routing
const AuthLogin = Loadable(lazy(() => import('views/authentication/Login3')));
const AuthSelectOrganization = Loadable(lazy(() => import('views/authentication/SelectOrganization')));
const AuthRegister = Loadable(lazy(() => import('views/authentication/Register3')));
const AuthEmbeddedRegister = Loadable(lazy(() => import('views/authentication/EmbeddedRegister3')));
const AuthForgotPassword = Loadable(lazy(() => import('views/authentication/ForgotPassword3')));
const AuthResetPassword = Loadable(lazy(() => import('views/authentication/ResetPassword3')));
const AuthSetupPassword = Loadable(lazy(() => import('views/authentication/SetupPassword')));
const AuthRegistrationPending = Loadable(lazy(() => import('views/authentication/RegistrationPending')));
const AuthDeleteAccount = Loadable(lazy(() => import('views/authentication/DeleteAccount')));
const AuthRegisterOrganization = Loadable(lazy(() => import('views/authentication/RegisterOrganization')));
const AuthTwoFactor = Loadable(lazy(() => import('views/authentication/TwoFactorAuth')));

// for email verification page on ui
const AuthEmailVerificationPending = Loadable(lazy(() => import('views/authentication/EmailVerificationPending')));
const EmailChangeSuccess = Loadable(lazy(() => import('views/email-verification/EmailChangeSuccess')));
const EmailChangeExpired = Loadable(lazy(() => import('views/email-verification/EmailChangeExpired')));
const EmailChangePending = Loadable(lazy(() => import('views/email-verification/EmailChangePending')));
const VerificationLinkInvalid = Loadable(lazy(() => import('views/email-verification/VerificationLinkInvalid')));
const EmailVerified = Loadable(lazy(() => import('views/email-verification/EmailVerified')));
const EmailAlreadyVerified = Loadable(lazy(() => import('views/email-verification/EmailAlreadyVerified')));
// ==============================|| AUTH ROUTING ||============================== //

const LoginRoutes = {
    path: '/',
    element: (
        <NavMotion>
            <MinimalLayout />
        </NavMotion>
    ),
    children: [
        // Routes without GuestGuard - accessible whether logged in or not
        {
            path: '/email-change-success',
            element: <EmailChangeSuccess />
        },
        {
            path: '/email-change-expired',
            element: <EmailChangeExpired />
        },
        {
            path: '/email-change-pending',
            element: <EmailChangePending />
        },
        {
            path: '/email-verified',
            element: <EmailVerified />
        },
        {
            path: '/verification-link-invalid',
            element: <VerificationLinkInvalid />
        },
        {
            path: '/email-already-verified',
            element: <EmailAlreadyVerified />
        },
        // Routes with GuestGuard - redirect to dashboard if logged in
        {
            path: '/',
            element: (
                <GuestGuard>
                    <AuthLogin />
                </GuestGuard>
            )
        },
        {
            path: '/login',
            element: (
                <GuestGuard>
                    <AuthLogin />
                </GuestGuard>
            )
        },
        {
            path: '/registration-pending',
            element: (
                <GuestGuard>
                    <AuthRegistrationPending/>
                </GuestGuard>
            )
        },
        {
            path: "/email-verification-pending",
            element: (
                <GuestGuard>
                    <AuthEmailVerificationPending/>
                </GuestGuard>
            )
        },
        {
            path: '/selectOrganization',
            element: (
                <GuestGuard>
                    <AuthSelectOrganization />
                </GuestGuard>
            )
        },
        {
            path: '/register/:organizationID',
            element: (
                <GuestGuard>
                    <AuthRegister />
                </GuestGuard>
            )
        },
        {
            path: '/embeddedRegister/:organizationID',
            element: (
                <GuestGuard>
                    <AuthEmbeddedRegister />
                </GuestGuard>
            )
        },
        {
            path: '/forgot',
            element: (
                <GuestGuard>
                    <AuthForgotPassword />
                </GuestGuard>
            )
        },
        {
            path: '/reset',
            element: (
                <GuestGuard>
                    <AuthResetPassword />
                </GuestGuard>
            )
        },
        {
            path: '/setup-password',
            element: (
                <GuestGuard>
                    <AuthSetupPassword />
                </GuestGuard>
            )
        },
        {
            path: '/deleteAccount',
            element: (
                <GuestGuard>
                    <AuthDeleteAccount />
                </GuestGuard>
            )
        },
        {
            path: '/registerOrganization',
            element: (
                <GuestGuard>
                    <AuthRegisterOrganization />
                </GuestGuard>
            )
        },
        {
            path: '/2fa',
            element: (
                <GuestGuard>
                    <AuthTwoFactor />
                </GuestGuard>
            )
        },
        {
            path: '/2fa-setup',
            element: (
                <GuestGuard>
                    <TwoFactorSetupPage />
                </GuestGuard>
            )
        }
    ]
};

export default LoginRoutes;
